module.exports = __webpack_public_path__ + "img/avatar5.a4d37e09.png";